module.exports = __webpack_public_path__ + "img/Default.90420f65.png";